<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="商品管理类型参数" :breadcrumbItem="[{to:'/goods/type',name:'商品类型'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品管理类型参数
      <small>定义商品类型参数...</small>
    </h1>
    <!-- end page-header -->
    <panel title="类型参数列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm m-r-5" @click="fn_add">
          <i class="fa fa-plus"></i> 新增参数
        </button>
        <button class="btn btn-theme btn-sm" icon="md-arrow-round-back" @click="$router.go(-1);">
          <i class="fa fa-arrow-left"></i> 返回
        </button>
      </div>
      <Row class="m-b-10" :gutter="5">
        <Col span="4">
          <Select v-model="filterCond.typeid">
            <Option v-for="(v,k) in typeList" :key="k" :value="v.id" :label="v.type_name"></Option>
          </Select>
        </Col>
        <Col span="4">
          <Input placeholder="参数名称" style="width: auto" v-model="filterCond.attr_name">
            <Icon type="ios-search" slot="suffix" />
          </Input>
        </Col>
        <Col span="2">
          <button type="button" @click="fn_query" class="btn btn-theme">查询</button>
        </Col>
      </Row>
      <Table size="small" :columns="columns" :data="data">
        <template slot-scope="{row}" slot="type_name">{{row.goodstype.type_name}}</template>
        <template slot-scope="{row}" slot="filtertype">
          <span v-if="row.filtertype =='no'">非检索属性</span>
          <span v-else-if="row.filtertype =='keywords'">关键字检索</span>
          <span v-else>范围检索</span>
        </template>
        <template slot-scope="{row}" slot="attr_input_type">
          <span v-if="row.attr_input_type =='input'">单行输入框</span>
          <span v-else-if="row.attr_input_type =='textarea'">多行输入框</span>
          <span v-else-if="row.attr_input_type =='radio'">单选输入框</span>
          <span v-else-if="row.attr_input_type =='checkbox'">多选框</span>
          <span v-else-if="row.attr_input_type =='select'">下拉选择框</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >修改</button>

          <Poptip
            transfer
            confirm
            title="是否要删除此类型以及对应的属性?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer title="商品类型参数" v-model="v_edit_typeattribute" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="商品类型" prop="typeid">
          <Select v-model="formData.typeid">
            <Option v-for="(v,k) in typeList" :key="k" :value="v.id" :label="v.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="参数名称" label-position="top" prop="attr_name">
          <Input v-model="formData.attr_name" placeholder="参数名称" />
        </FormItem>
        <FormItem label="输入方式" label-position="top">
          <RadioGroup v-model="formData.attr_input_type">
            <Radio label="input">单行输入框</Radio>
            <Radio label="textarea">多行输入框</Radio>
            <Radio label="radio">单选框</Radio>
            <Radio label="checkbox">多选框</Radio>
            <Radio label="select">下拉框</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="检索" label-position="top">
          <RadioGroup v-model="formData.filtertype">
            <Radio label="no">不检索</Radio>
            <Radio label="keywords">关键字</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="可选择数值">
          <Input type="textarea" :rows="4" v-model="formData.attr_options" />
          <span class="block-help">多个数值可通过###分开</span>
        </FormItem>
        <FormItem label="排序">
          <InputNumber v-model="formData.sortval"></InputNumber>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_typeattribute = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import {
  getTypeList,
  getTypeAttributeList,
  storeTypeAttributeData,
  removeTypeAttributeData
} from "@/api/goods";
export default {
  components: { breadcrumb },
  data() {
    return {
      columns: [
        {
          title: "参数名称",
          key: "attr_name",
          width: 150
        },
        {
          title: "类型名称",
          slot: "type_name",
          width: 150
        },

        {
          title: "检索方式",
          slot: "filtertype",
          width: 120
        },

        {
          title: "输入方式",
          slot: "attr_input_type",
          width: 120
        },
        {
          title: "备选列表",
          key: "attr_options"
        },
        {
          title: "排序",
          key: "sortval",
          width: 100
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center"
        }
      ],
      data: [],
      formData: {
        id: 0,
        typeid: 0,
        attr_name: "",
        attr_input_type: "",
        filtertype: "",
        attr_options: "",

        sortval: 0,
        userid: 0
      },
      rules: {
        typeid: [
          {
            type: "number",
            min: 0.1,
            required: true,
            message: "类型必填",
            tirgger: "change"
          }
        ],
        attr_name: [
          {
            required: true,
            message: "名称必填",
            tirgger: "blur"
          }
        ]
      },
      v_edit_typeattribute: false,
      totalRows: 0,
      pageNum: 10,
      currentPage: 1,
      goodstype: {},
      typeList: [],
      filterCond: {
        typeid: 1,
        attr_name: ""
      }
    };
  },
  mounted() {
    this.goodstype = this.$route.params.data;

    if (typeof this.goodstype !== "undefined") {
      let filterCond = {
        typeid: this.goodstype.id,
        page: 1,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    } else {
      this.goodstype = {
        id: 0,
        type_name: ""
      };
    }
    getTypeList({ page: 0, pageNum: 0 })
      .then(res => {
        this.typeList = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
    this.filterCond.typeid = this.goodstype.id;
    console.log(this.filterCond);
  },
  methods: {
    fn_query() {
      this.filterCond.page = 1;
      this.filterCond.pageNum = this.pageNum;
      this.fn_load_data(this.filterCond);
    },
    fn_load_data(filterCond) {
      getTypeAttributeList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_add() {
      this.v_edit_typeattribute = true;
      this.formData = {
        id: 0,
        typeid: 0,
        attr_name: "",
        attr_input_type: "input",
        filtertype: "no",
        attr_options: "",

        sortval: 0,
        userid: 0
      };
    },
    fn_edit(row, index) {
      this.formData = row;
      this.v_edit_typeattribute = true;
    },
    fn_remove(row, index) {
      removeTypeAttributeData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      let filterCond = {
        id: this.goodstype.id,
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeTypeAttributeData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.v_edit_typeattribute = false;
                if (this.formData.id == 0) this.data.unshift(res.data.data);
                this.$Notice.success(res.data);
              } else this.$Notice.error(res.data);
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    }
  }
};
</script>